<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>体验课订单（店铺）<span class="time">{{ dorisTime }}更新</span></h3>
        <div class="refresh">手动刷新页面，拉取实时体验课订单数据</div>
      </div>
      <div class="topRight">
        <div>管理员能看到所有成员的订单<br />普通成员只能看到自己的和无归属人的订单<br/>后台数据包含退费订单，实际数据需与对接人确认</div>
      </div>
      <div class="statistics" v-if="statisticsArr.length > 0">
         <li class="card" v-for="(item, index) in statisticsArr" :key='index'>
          <div class="date">{{item.label}}
            <el-tooltip v-if="item.show" class="item" effect="dark" placement="top-start">
              <div slot="content" style="line-height:18px">
                1-订单集合，按照支付时间统计，包括已支付和已退费，不包括未支付。<br />
                2-管理员角色时，包括团队所有成员的订单。<br />
                3-普通成员角色时，只包括归属人是自己的订单，不包括无归属人订单。
              </div>
              <i class="el-icon-info"></i>
            </el-tooltip>
          </div>
          <div class="sum">{{numberFormat(item.number)}}</div>
        </li>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="支付时间">
          <el-date-picker
            v-model="createTime"
            value-format="timestamp"
            type="datetimerange"
            :picker-options="pickerOptions"
            @blur="enableChoose"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:235px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="体验课订单号">
          <el-input v-model="listQuery.order_no" placeholder="输入订单号查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="三方订单号">
          <el-input v-model="listQuery.third_order_no" placeholder="输入订单号查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="学科">
          <el-select v-model="listQuery.subject_type" multiple filterable clearable placeholder="选择查询">
            <el-option
              v-for="subject in subjects"
              :key="subject"
              :label="subject"
              :value="subject"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否激活">
          <el-select v-model="listQuery.is_active" filterable placeholder="选择查询">
            <el-option label="全部" :value="null" />
            <el-option label="激活" :value="1" />
            <el-option label="未激活" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="渠道组ID">
          <el-select
            v-model="listQuery.channel_group_id"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入渠道组ID查询"
            :remote-method="query => queryChannel(query, true)"
            :loading="selectLoading">
            <el-option
              v-for="item in channelGroups"
              :key="item.channelGroupId"
              :label="`${item.channelGroupId}${item.channelGroupName}`"
              :value="item.channelGroupId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子渠道ID">
          <el-select
            v-model="listQuery.channel_id"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入子渠道ID查询"
            :remote-method="queryChannel"
            :loading="selectLoading">
            <el-option
              v-for="item in channels"
              :key="item.id"
              :label="`${item.id}${item.description}`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道子类型" label-width="150px">
          <el-select v-model="channelSubtypeId" multiple filterable clearable placeholder="选择查询" @change="changeChannelSubtypeId">
            <el-option
              v-for="channel in channelSubtypes"
              :key="channel.id"
              :label="channel.channelTypeCidName"
              :value="channel.channelTypeCid"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="支付金额">
          <el-input-number v-model="listQuery.pay_amount" :precision="1" :controls="false" placeholder="输入支付金额" class="orderStyle" />
        </el-form-item> -->
        <el-form-item label="是否续报">
          <el-select v-model="listQuery.is_renewal" placeholder="选择查询">
            <el-option key=0 label="全部" :value=null />
            <el-option key=1 label="是" :value="1" />
            <el-option key=2 label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <!-- 下载组建 -->
        <DownExcel
          :listQuery="listQuery"
          :createTime="createTime"
          :total="total"
          pageType="thirdpartyTrial"
        />
      </el-form>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="支付时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.pay_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课订单号" align="center" min-width="200">
          <template slot-scope="{row}">
            <span>{{ row.order_no || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="三方订单号" align="center" min-width="200">
          <template slot-scope="{row}">
            <span>{{ row.third_order_no || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" align="center" min-width="200">
          <template slot-scope="{row}">
            <span>{{ row.third_real_pay ? numberFormatRgx2(row.third_real_pay / 100) : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道组名称" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.channel_group_name || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道子类型" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.channel_subtype_name || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="子渠道ID" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.channel_id_name || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课学期" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.term_id_name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学科" align="center" width="80">
          <template slot-scope="{row}">
            <span>{{ row.subject_type || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.user_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="年级" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.pay_grade }}</span>
          </template>
        </el-table-column>
        <el-table-column label="省" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.parents_province }}</span>
          </template>
        </el-table-column>
        <el-table-column label="市" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.parents_city }}</span>
          </template>
        </el-table-column>
        <el-table-column label="城市等级" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.parents_city_level }}</span>
          </template>
        </el-table-column>
        <el-table-column label="年龄" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.child_age }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开课日期" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.classopen_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否续报" align="center" width="100" v-if="renewShow">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="续报数据延迟一天，今天只能看到昨天续报的" placement="top">
              <span class="icon-question">是否续报</span>
            </el-tooltip>
          </template>
          <template slot-scope="{row}">
            <span>{{ row.is_renewal == '1' ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="续报是否退费" align="center" min-width="100" v-if="refundShow">
          <template slot-scope="{row}">
            <span>{{ row.is_refund == '1' ? '是' : '否' || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.index"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { mapGetters } from 'vuex'
import Pagination from "@/components/Pagination/index";
import DownExcel from "@/components/DownExcel/index";
import { getThirdTrialOrderList, getStatistics, getDorisTime, getThirdTrialOrderStatus, queryChannelGroup, queryChannel, getChannelList } from "@/services/order";
import PowerWrapper from "@/components/PowerWrapper";
import { timestampToDate, delUndefined, numFormat, formatNumberRgx2, timestampToDateTotal } from "@/utils/utils";
import { getAgentCode, getTeamCode, getTeamRole, isThirdParty } from '@/utils/auth'

export default {
  name: "order",
  components: {
    Pagination,
    PowerWrapper,
    DownExcel,
  },
  data() {
    return {
      CurrRole: "order",
      dorisTime: "",
      isThirdParty: isThirdParty(),
      selectLoading: false,
      list: [],
      total: 0,
      emptyText: '暂无数据',
      subjects: [
        "Script",
        "Go",
        "Write",
        "Hardware",
        "Python",
        "PythonMorton",
        "Reading",
        "Science",
        "ScratchJr",
        "ScratchMorton",
        "MathBox",
      ],
      listQuery: {
        index: 1,
        pageSize: 10,
        order_no: '',
        third_order_no: '',
        subject_type: '',
        is_active: null,
        channel_group_id: '',
        channel_id: '',
        channel_subtype_id: '',
      },
      channelSubtypeId: [],
      channelGroups: [],
      channelSubtypes: [],
      channels: [],
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date().getTime()],
      statisticsArr: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
      },
      pickerMinDate: "", // 第一次选中的时间
      thirdTrialOrderStatus: [],
    };
  },
  computed: {
    ...mapGetters([
      'renewShow',
      'refundShow',
      'repeatBuy',
    ]),
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.getList()
    // 统计接口
    this.getStatistics()
    // 获取数据更新时间
    this.getDorisTime()
    this.getThirdTrialOrderStatus()
    this.getChannelList()
  },
  mounted() {
  },
  methods: {
    changeChannelSubtypeId(value) {
      this.listQuery.channel_subtype_id = value.join(',')
    },
    async getChannelList() {
      try {
        const { data: { data, errCode } } = await getChannelList()
        if (errCode === 0) {
          this.channelSubtypes = data || []
        }
      } catch (error) {
        this.$message({ type: 'error', message: '子渠道类型获取失败，请稍后重试！' })
        console.log(error)
      }
    },
    numberFormatRgx2(num) {
      return formatNumberRgx2(num)
    },
    async queryChannel(query, isGroup) {
      const queryFn = isGroup ? queryChannelGroup : queryChannel;
      const channelValue = isGroup ? 'channelGroups' : 'channels';
      let arr = [];
      if (query !== '') {
        this.selectLoading = true;
        try {
          const res = await queryFn(query);
          const { data, errCode } = res.data;
          console.log('==== ', errCode, data);
          if (errCode === 0 && data) arr = [data];
        } catch (e) {
          console.error('queryChannel error: ', e);
        }
      }
      this.selectLoading = false;
      this[channelValue] = arr;
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    numberFormat(num) {
      return numFormat(num)
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    async getThirdTrialOrderStatus() {
      try {
        const { data: { data, errCode } } = await getThirdTrialOrderStatus()
        console.table(data)
        if (errCode === 0) {
          this.thirdTrialOrderStatus = data;
        }
      } catch (err) {
        console.log(err)
      }
    },
    getDorisTime() {
      getDorisTime().then(res => {
        const { lastUpdateTime } = res.data || {}
        this.dorisTime = lastUpdateTime;
      });
    },
    getStatistics() {
      this.updateTime = Date.parse(new Date());
      const params = {
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        agentCode: getAgentCode()
      }
      getStatistics(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          const orderList = res.data.data;
          if (orderList && orderList.length > 0) {
            this.statisticsArr = orderList.map(element => {
              if (element && element.timeType) {
                return {
                  label: element.timeType === 'today' ? '今日订单量'
                    : element.timeType === 'week' ? '本周订单量'
                      : element.timeType === 'month' ? '本月订单量'
                        : element.timeType === 'total' ? '累计订单总量' : '',
                  number: element.number || 0,
                  show: element.timeType === 'today'
                }
              }
            });
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.statisticsArr = [];
        }
      });
    },
    getList(btnName) {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const _listQuery = Object.assign({}, listQuery);
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (query === 'all') {
          delete _listQuery[key]
        } else if (Array.isArray(query) && query.indexOf('all') > -1) {
          Object.assign(_listQuery, {
            [key]: null
          })
        }
      });
      const params = {
        ..._listQuery,
        index: btnName === 'search' ? 1 : this.listQuery.index,
        start_pay_time: createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_pay_time: createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        agentCode: getAgentCode()
      }
      getThirdTrialOrderList({
        type: 'POST',
        params: {
          ...delUndefined(params)
        }
      }).then((res = {}) => {
        const { errCode, errMsg, data, total } = res.data || {};
        if (errCode === 0 && Array.isArray(data) && data.length > 0) {
          this.listLoading = false;
          this.list = data;
          this.total = total;
          if (btnName === 'search') {
            this.listQuery.index = 1;
          }
        } else if (errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.emptyText = errMsg && errMsg !== 'success' ? errMsg : '暂无数据';
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      });
    },
    handleSearch() {
      this.getList('search');
    },
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.icon-question{
  cursor: pointer;
}
</style>
